import apisauce from 'apisauce'
import { baseURL, timeout } from './config'

export default apisauce.create({
  baseURL,
  timeout,
  withCredentials: true,
})
